import {
  hasCompleteQueryData,
  throwOnQueryError,
} from 'ZalamoLibrary/src/lib/core/graphql/complete-query-data';

import { filter, first, map, pipe, switchMap } from 'rxjs';

import { Injectable } from '@angular/core';
import {
  GetLastSeenDocument,
  GetLastSeenGQL,
  GetLastSeenQuery,
  GetLastSeenQueryVariables,
  InsertLastSeenActionGQL,
} from 'ZalamoLibrary/src/lib/zalamo/last-seen-helper/graphql';
import { ZalamoObject } from './graphql';
import { OrganizationService } from 'ZalamoLibrary/src/lib/core/organizations/organization.service';

@Injectable({
  providedIn: 'root',
})
export class LastSeenServiceService {
  constructor(
    private insertLastSeenActionGQL: InsertLastSeenActionGQL,
    private organizationService: OrganizationService,
    private getLastSeenGQL: GetLastSeenGQL,
  ) {}

  addViewEvent(object: ZalamoObject, objectId: string) {
    this.organizationService
      .getCurrentOrganization()
      .pipe(
        switchMap((organizationId) =>
          this.insertLastSeenActionGQL.mutate({
            ...{
              update: (cache, result) => {
                const variables: GetLastSeenQueryVariables = {
                  object,
                  organizationId,
                };
                const current = {
                  ...cache.readQuery<GetLastSeenQuery>({
                    query: GetLastSeenDocument,
                    variables,
                  }),
                };
                if (current?.geLastSeenForType) {
                  current.geLastSeenForType = [...current.geLastSeenForType];
                  const alreadyExists =
                    current.geLastSeenForType.indexOf(objectId);
                  if (alreadyExists !== -1) {
                    current.geLastSeenForType.splice(
                      current.geLastSeenForType.indexOf(objectId),
                      1,
                    );
                  }
                  current.geLastSeenForType.unshift(objectId);
                  cache.writeQuery({
                    query: GetLastSeenDocument,
                    variables,
                    data: current,
                  });
                }
              },
            },
            variables: {
              object,
              objectId,
              organizationId,
            },
          }),
        ),
      )

      .pipe(first())
      .subscribe();
  }

  getLastObjectViews(object: ZalamoObject) {
    return this.organizationService.getCurrentOrganization().pipe(
      switchMap((organizationId) =>
        this.getLastSeenGQL
          .watch({
            variables: {
              object,
              organizationId,
            },
          })
          .valueChanges.pipe(
            throwOnQueryError,
            filter(hasCompleteQueryData),
            map((result) => result.data['geLastSeenForType']),
          ),
      ),
    );
  }
}
